import { render, staticRenderFns } from "./ModalFormEstablecerPlanPagoProgramaUniversidad.vue?vue&type=template&id=dccc7302"
import script from "./ModalFormEstablecerPlanPagoProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormEstablecerPlanPagoProgramaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports